import OwnerObj from "../classes/Owner";
import ScenarioObj from "../classes/Scenario";

class PropertyObj {

	
	constructor() {
		

	}
	
	
	
	static getLowestState(stateList, scenario, propertyId){
		
		
		var states = [];
		var property = ScenarioObj.getPropertyByVindrId(scenario, propertyId);
		
		if(!Array.isArray(property.properties.ownerid) || !property.properties.ownerid.length)
			return false;
		property.properties.ownerid.forEach((ownerId)=>{
			
			var state = OwnerObj.getPropertyState(ScenarioObj.getOwner(scenario, ownerId), property.properties.vindrid);
			
			states.push(stateList.findIndex((s)=>{return s == state}));
			
		});
		return stateList[Math.min.apply(null, states)];
		
	}
	

}

export default PropertyObj;